/*
 * Filter for the Vehicle Grid to sort into different types
 * (Car, Truck, SUV etc) and allow for filtering based on this
 */

export const getActiveBodyStyleFilterStatus = (state, bodyStyle) =>
state.bodyStyleFilter.filter.find(bs => bs === bodyStyle) !== undefined;

export const getActiveBodyStyleOrAllFilterStatus = (state, bodyStyle) =>
state.bodyStyleFilter.filter.find(bs => bs === bodyStyle || bs === 'all') !== undefined;



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/bodyStyleFilter.js
 **/